module.exports = __webpack_public_path__ + "static/us-enterprise-learner-success-b8a0df3868a428118e09a784de56684c.gif";